import React, { useEffect, useState } from 'react';
import TopHeader from './side/TopHeader';
import Sidebar from './side/Sidebar';
import '../css/AdminManagement.css';
import axios from 'axios';
import { SERVER_URL } from '../../config/config';
import { useNavigate } from 'react-router-dom';
import ModelDetailModal from './ModelDetailModal';
import Pagination from './side/Pagination';

// 인라인 ProgressBar 컴포넌트
function ProgressBar({ value, color = 'red' }) {
  const percent = Math.round(value * 100);
  return (
    <div style={{ display: 'flex', alignItems: 'center', minWidth: 80 }}>
      <div style={{
        width: 100,
        height: 8,
        background: '#222',
        borderRadius: 4,
        marginRight: 8,
        overflow: 'hidden',
        position: 'relative',
      }}>
        <div style={{
          width: `${percent}%`,
          height: '100%',
          background: color,
          borderRadius: 4,
          transition: 'width 0.3s',
        }} />
      </div>
      <span style={{ fontWeight: 500, fontSize: 16 }}>{percent}</span>
    </div>
  );
}

function VersionManagement() {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [selectedModel, setSelectedModel] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 5;

  useEffect(() => {
    const fetchVersions = async () => {
      setLoading(true);
      setError(null);
      try {
        const admin_id = localStorage.getItem('admin_id') || '1';
        const res = await axios.get(`${SERVER_URL}/admin/ai/model/all?admin_id=${admin_id}`);
        if (res.data.result_code === 201 && Array.isArray(res.data.models)) {
          setVersions(res.data.models);
        } else {
          setError('데이터를 불러오지 못했습니다.');
        }
      } catch (err) {
        setError('서버 오류가 발생했습니다.');
      }
      setLoading(false);
    };
    fetchVersions();
  }, []);

  // 실행중인 모델이 맨 위로 오도록 정렬
  const sortedVersions = [...versions].sort((a, b) => (b.selected ? 1 : 0) - (a.selected ? 1 : 0));

  // 현재 페이지 데이터 추출
  const getCurrentPageItems = (items, currentPage) => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    return items.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };
  const totalPages = Math.ceil(sortedVersions.length / ITEMS_PER_PAGE);

  if (loading) {
    return (
      <div className="user-management">
        <div className="user-content-wrapper">
          <Sidebar />
          <div className="user-main-content">
            <div className="loading">Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="header-section">
            <h1>버전 관리</h1>
            <button 
              className="button" 
              onClick={() => navigate('/ai/train')}
              style={{ marginRight: '10px' }}
            >
              새 버전 추가
            </button>
          </div>

          <div className="table-container">
            <div className="header-row" style={{ gridTemplateColumns: '7% 6% 18% 14% 14% 40%' , borderBottom: 'none' }}>
              <span></span>
              <span>버전번호</span>
              <span>출시일</span>
              <span>Accuracy</span>
              <span>F1-Score</span>
              <span style={{ textAlign: 'left', marginLeft: '6px' }}>Key Updates</span>
            </div>
            <div className="data-entries">
              {error ? (
                <div className="table-row">
                  <span className="cell" style={{ fontSize: '18px', gridColumn: '1 / -1', color: '#888' }}>
                    {error}
                  </span>
                </div>
              ) : (
                getCurrentPageItems(sortedVersions, currentPage).map((v, idx) => (
                  <div 
                    key={idx}
                    className="table-row"
                    style={{ 
                      display: 'grid', 
                      gridTemplateColumns: '7% 6% 18% 14% 14% 40%',  
                      boxSizing: 'border-box'
                    }}
                    onClick={() => {
                      setSelectedModel(v);
                      setShowModal(true);
                    }}
                  >
                      {v.selected ? (
                        <span
                          className="cell" 
                          style={{
                            background: '#6ee06e',
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: 12,
                            borderRadius: 6,
                            padding: '2px 8px',
                            marginLeft: 6,
                            verticalAlign: 'middle',
                        }}>
                          실행중
                        </span>
                      ) : (
                        <span className="cell"></span>
                      )}
                    <span className="cell">
                      {v.version}
                    </span>
                    <span className="cell">{v.released_date}</span>
                    <span className="cell"><ProgressBar value={v.accuracy} color="#F30F13" /></span>
                    <span className="cell"><ProgressBar value={v.f1_score} color="#F30F13" /></span>
                    <span className="cell" style={{ textAlign: 'left', marginLeft: '6px', justifyContent: 'flex-start' }}>{v.key_updates}</span>
                  </div>
                ))
              )}
            </div>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      {showModal && selectedModel && (
        <ModelDetailModal
          model={selectedModel}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
}

export default VersionManagement; 